import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vQuestionListBase {

//#region questionId Prop
        @gridColumn({visible: false, columnIndex:0, allowSorting: true, headerKey: 'questionId', keyColumn: true})
        questionId : number;
//#endregion questionId Prop


//#region questionText Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'questionText', keyColumn: false,headerTitle: "Question Text"})
        questionText : string;
//#endregion questionText Prop


//#region questionType Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'questionType', keyColumn: false,headerTitle: "Question Type"})
        questionType : string;
//#endregion questionType Prop


//#region options Prop
        @gridColumn({visible: true, columnIndex:3, allowSorting: true, headerKey: 'options', keyColumn: false,headerTitle: "Options"})
        options : string;
//#endregion options Prop


//#region status Prop
        @gridColumn({visible: true, columnIndex:5, allowSorting: true, headerKey: 'status', keyColumn: false, headerTitle: "Status", configuredTemplate: { templateName: "recordActive" }})
        status : string;
//#endregion status Prop

}